<template>
  <el-dialog
    title="修改密码" :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="cancel"
    width="600px"
  >
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="密码" prop="pass">
        <el-input
          type="password"
          v-model="ruleForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          type="password"
          v-model="ruleForm.checkPass"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <div class="el-button-align-right">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="submitForm" class="sureWidth"
            >确定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import md5 from "js-md5"
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: true,
      ruleForm: {
        password: "",
        checkPass: "",
      },
      rules: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let obj=JSON.parse(JSON.stringify(this.ruleForm))
          obj.password=md5(obj.password)
          WAPI.updatePassword(obj).then((data) => {
            switch (data.code) {
              case 200:
              this.commonApi.successTip(data.msg);
              this.$emit("submit");
            }
          });
        }
      });
    },
    cancel() {
      this.$emit("cancel");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/layout/components/modifyPass.vue